import { AMOUNT_OPTIONS, COMMUNITY_BELONG, REPRESENTATION_TYPE } from "@/api.graphql.generated"

export const ANCESTORS = [
  {
    value: COMMUNITY_BELONG.NOT_INFORMED,
    label: "Prefiro não informar",
  },
  { label: "Comunidades quilombolas", value: COMMUNITY_BELONG.QUILOMBOLA },
  { label: "Comunidades indígenas", value: COMMUNITY_BELONG.INDIGENOUS },
  { label: "Ocupações", value: COMMUNITY_BELONG.OCUPATION },
  { label: "Abrigos", value: COMMUNITY_BELONG.SHELTER },
  { label: "Nenhuma das alternativas", value: COMMUNITY_BELONG.NONE },
]

export const OTHER_VALUE = "OUTRO"

export const DISCAPACITY = [
  {
    value: "NAO_INFORMAR",
    label: "Prefiro não informar",
  },
  { label: "Física", value: "FISICA" },
  { label: "Visual", value: "VISUAL" },
  { label: "Auditiva", value: "AUDITIVA" },
  { label: "Intelectual", value: "INTELECTUAL" },
  { label: "Neuromotora", value: "NEUROMOTORA" },
  { label: "Surdocegueira", value: "SURDOCEGUEIRA" },
  { label: "Múltiplas", value: "MULTIPLAS" },
  { label: "Neuroatípico - Neurodivergente", value: "NEUROATIPICO_NEURODIVERGENTE" },
  { label: "Psicoatípico", value: "PSICOATIPICO" },
  { label: "Não sou pessoa com deficiência", value: "NAO_SOU_PESSOA_COM_DEFICIÊNCIA" },
  { label: "Outros", value: OTHER_VALUE },
]

export const FEAT_OPTIONS = [
  {
    track: "axe",
    value: "AXE",
    label: "Axé",
    title: "CORAL FEAT DANIELA MERCURY",
    text: `Cantora e compositora de Jequié, Bahia, Coral é uma presença significativa na cena musical independente. Sua voz inconfundível dá vida a uma poesia engajada e potente a partir de seu lugar como artista, nordestina e travesti, imprimindo sua identidade afetuosa na canção brasileira contemporânea. Seus últimos lançamentos são as canções “Ressonância”, com Chico César, “Serra”, com Fernanda Takai, e o EP “Tudo o que você podia ser”, trilha sonora original do filme de mesmo nome. Coral também protagoniza o documentário “Um Ano” (2024, dir. Pri Garcia), que conta sobre seu retorno ao carnaval de Belo Horizonte em 2024 após sofrer uma agressão no carnaval do ano anterior.`,
    artistName: "Daniela Mercury",
    artistPicture: require("../assets/artists/Coral_MiniBio.webp").default,
  },
  {
    track: "boi-da-amazonia",
    value: "BOI_DA_AMAZONIA",
    label: "Boi da Amazônia",
    title: "KETLEN NASCIMENTO FEAT GARANTIDO E CAPRICHOSO",
    text: `Ketlen Nascimento, cantora, compositora, psicóloga especialista em Psicomotricidade, Gerontologia e Saúde do Idoso e Musicoterapia, membro Imortal da Academia Amazonense de Música.<br/><br/>Em 2010 lançou CD e DVD, intitulado “KETLENCANTAMAZONIA”, gravado no Teatro Amazonas, com composições de sua autoria.`,
    artistName: "Garantido e Caprichoso",
    artistPicture: require("../assets/artists/Ketlen Nascimento_MiniBio.webp").default,
  },
  {
    track: "carimbo",
    value: "CARIMBO",
    label: "Carimbó",
    title: "AMANDA PACÍFICO FEAT DONA ONETE E SURARAS DO TAPAJÓS",
    text: `Amanda Pacífico é cantora e compositora, nascida em Belém do Pará. Em sua passagem por São Paulo e Curitiba, integrou a banda Mulamba, com quem gravou dois álbuns e participou de importantes festivais no Brasil, como Lollapalooza e SeRasgum. Em 2022, foi uma das intérpretes do álbum Onze (Músicas Inéditas de Adoniran Barbosa), concorrendo ao Grammy Latino como Melhor Álbum de Samba. Atualmente de volta à Belém, prepara seu primeiro álbum solo, em busca de novas sonoridades, com temas presentes em seu cotidiano no norte do Brasil.`,
    artistName: "Dona Onete",
    artistPicture: require("../assets/artists/Amanda Pacífico_MiniBio.webp").default,
  },
  {
    track: "forro",
    value: "FORRO",
    label: "Forró",
    title: "ZENAIDE PARTEIRA FEAT GERALDO AZEVEDO",
    text: `Descendente da cultura Kampa, povo Ashaninka, Maria Zenaide é uma acreana que vive há anos ajudando mulheres a se tornarem mães, através do dom que herdou de sua mãe como parteira tradicional.<br/><br/>Acostumada a realizar partos difíceis dentro da mata fechada da Floresta Amazônica, ao mudar-se para Rio Branco, logo se tornou reconhecida como liderança do movimento das parteiras visando o empoderamento das mulheres e a busca de direitos.<br/><br/>Uma tradição embalada pelas músicas que aprendeu, ouviu e escreveu ao longo dos anos como parteira. Suas músicas versam sobre a luta das mulheres, o trabalho das parteiras, a natureza, o amor e tantas outras poéticas da vida junto da floresta, buscando inspiração em cada parto realizado, em suas próprias vivências e nas histórias que ouviu.`,
    artistName: "Geraldo Azevedo",
    artistPicture: require("../assets/artists/Zenaide Parteira_MiniBio2.webp").default,
  },
  {
    track: "funk-carioca",
    value: "FUNK_CARIOCA",
    label: "Funk Carioca",
    title: "P0CKET FEAT VALESCA POPOZUDA",
    text: `P0CKET, 28 anos, natural de Cuiabá-MT, moradora do complexo da Maré, Rio de Janeiro. É poeta, atriz, cantora e compositora. Na música tem feats com Mac Júlia, Deize Tigrona, Shevchenko, entre outros. Participou do projeto de aceleração artística da Fundição Progresso “Estude o Funk”, desde então vem se destacando na cena do Funk com sua estética única. Foi selecionada para o edital da Mostra Maré de Música, onde pôde gravar Ao lado de Ruxell, Sabrina Azevedo e Pablo Bispo no renomado estúdio Toca do Bandido. É Formada em Teatro pela ETEC de Artes de São Paulo, Igbasile: Registros negros na dança - pelo CRD SP e História do Teatro africano pela SP escola de teatro.`,
    artistName: "Valesca Popozuda",
    artistPicture: require("../assets/artists/Pocket_MiniBio.webp").default,
  },
  {
    track: "maracatu",
    value: "MARACATU",
    label: "Maracatu",
    title: "MESTRE ANDERSON MIGUEL FEAT LENINE",
    text: `Incentivado pela família, aos 8 anos ele já participava de ensaios e encontros de Maracatu de Baque Solto na Zona da Mata de Pernambuco, imerso na tradição popular de origem afro-indígena elaborada por trabalhadores canavieiros do fim do século XIX.<br/><br/>Sob produção de Siba, “Sonorosa”, disco de Anderson, nos atravessa por um exercício de descolonização dos sentidos, pois desmonta o discurso paternalista que associa culturas populares afro brasileiras a um ideal folclórico, monolítico e estático que deve ser “conservado”.<br/><br/>Anderson está em estúdio finalizando o repertório para gravação do seu 2º álbum do Mestre Anderson Miguel e a Ciranda Raiz da Mata Norte, intitulado “Encanto e Poesia”, projeto incentivado pelo governo de Pernambuco através do Funcultura (Fundo Pernambucano de incentivo a cultural).`,
    artistName: "Lenine",
    artistPicture: require("../assets/artists/Mestre Anderson Miguel_MiniBio.webp").default,
  },
  {
    track: "milonga",
    value: "MILONGA",
    label: "Milonga",
    title: "JULIANO GUERRA FEAT FILIPE CATTO",
    text: `Juliano Guerra nasceu em Canguçu, Rio Grande do Sul, em 1983. É compositor, intérprete e instrumentista, tendo lançado 3 álbuns de estúdio: “Lama” (2012), “Sexta-feira” (2015) e “NEURA” (2018) - este último premiado com o Açorianos de melhor compositor. Radicado em Porto Alegre desde 2019, tem colaborado com artistas locais enquanto prepara seu quarto álbum. Em 2024 lançou o single “latinoamerica drama”, com participação de Vitor Ramil.`,
    artistName: "Filipe Catto",
    artistPicture: require("../assets/artists/Juliano Guerra_MinBio.webp").default,
  },
  {
    track: "rap-de-sao-paulo",
    value: "RAP_SAO_PAULO",
    label: "Rap de São Paulo",
    title: "MEIRE D’ORIGEM FEAT RAPPIN’HOOD",
    text: `Meire D’Origem, artista multifacetada, Cantora e MC, Arte Educadora, Produtora e agitadora Cultural, com mais de 2 décadas atuando no Hip Hop. Faz parte dos Coletivos TRILUNA, GT Mulheres da Cultura, Resistência Preta e Frente Nacional de Mulheres no Hip Hop.<br/><br/>Já percorreu diversos estados Brasileiros com o seu 1º Álbum “Se Renda”, lançado em 2013 ao lado do grupo D’Origem (primeiro álbum de rap feminino do Vale). Acaba de lançar o álbum solo EP “Sempre Estive Aqui”.<br/><br/>Foi premiada na categoria trajetória em 2020 pela LAB e em 2023  na categoria projeto com o projeto “O RAP é Meu Divã” pela LPG. É produtora e apresentadora do programa SindCT na Cultura, viabilizado pelo Sindicato de Ciência e Tecnologia do Setor Aeroespacial.`,
    artistName: "Rappin'hood",
    artistPicture: require("../assets/artists/Meire D_Origem_MiniBio.webp").default,
  },
  {
    track: "samba",
    value: "SAMBA",
    label: "Samba",
    title: "MAÍRA DA ROSA FEAT PÉRICLES",
    text: `Maíra da Rosa nasceu em Osasco/SP, passou a infância em Pernambuco, na Bahia e em Minas Gerais, e hoje mora na zona Oeste da cidade de São Paulo. Tem 41 anos, é cantora, compositora e pesquisadora de culturas negras e interseccionalidades. Estudou canto no Conservatório Villa Lobos, em Osasco/SP e na ETEC de Artes de São Paulo. É vocalista do grupo musical Samba de Dandara, que explora sambas, afoxés, a musicalidade afro-brasileira e o papel da mulher dentro desse universo, desde 2013. É mestre em Educação pela Pontifícia Universidade Católica de São Paulo.`,
    artistName: "Péricles",
    artistPicture: require("../assets/artists/Maíra da Rosa_MiniBio.webp").default,
  },
  {
    track: "tecnobrega-do-para",
    value: "TECNOBREGA_DO_PARA",
    label: "Tecnobrega do Pará",
    title: "WALDER WOLF FEAT GABY AMARANTOS",
    text: `Walder Wolf, cantor paraense nascido em Cametá, é um artista que expressa a essência da Amazônia em sua música. Crescido em meio a uma família de músicos, iniciou sua carreira solo em 2021, após anos de experiência como backvocal. Com uma voz marcante e uma proposta inovadora, Walder mistura ritmos amazônicos ao pop, criando o BEAT BREGA, um estilo único. Suas canções refletem memórias, vivências e o desejo de levar a riqueza cultural da Amazônia a palcos nacionais e internacionais, encantando com autenticidade, carisma e paixão.`,
    artistName: "Gaby Amarantos",
    artistPicture: require("../assets/artists/Walter Wolf_MiniBio.webp").default,
  },
]

export const GENDER_IDENTIFICATIONS = [
  {
    value: "NAO_INFORMAR",
    label: "Prefiro não informar",
  },
  { label: "Mulher trans", value: "MULHER TRANS" },
  { label: "Mulher cis", value: "MULHER CIS" },
  { label: "Homem cis", value: "HOMEM CIS" },
  { label: "Homem trans", value: "HOMEM TRANS" },
  { label: "Travesti", value: "TRAVESTI" },
  { label: "Não binárie", value: "NÃO BINÁRIE" },
  { label: "Outros", value: OTHER_VALUE },
]

export const NATIONALITIES = [
  {
    value: "BR",
    label: "Brasileiro",
  },
  {
    value: OTHER_VALUE,
    label: "Outra",
  },
]

export const QUANTITY_RANGES = [
  {
    value: AMOUNT_OPTIONS.LT5,
    label: "Menos de 5",
  },
  {
    value: AMOUNT_OPTIONS.GT5_LT10,
    label: "Entre 5 a 10",
  },
  {
    value: AMOUNT_OPTIONS.GT10_LT15,
    label: "Entre 10 e 15",
  },
  {
    value: AMOUNT_OPTIONS.GT15,
    label: "Acima de 15",
  },
]

export const RACIAL_ETHNIC_IDENTIFICATIONS = [
  {
    value: "NAO_INFORMAR",
    label: "Prefiro não informar",
  },
  {
    value: "PRETA",
    label: "Preta",
  },
  {
    value: "PARDA",
    label: "Parda",
  },
  {
    value: "INDIGENA",
    label: "Indígena",
  },
  {
    value: "AMARELA",
    label: "Amarela",
  },
  {
    value: "BRANCA",
    label: "Branca",
  },
]

export const REPRESENTATION_TYPES = [
  {
    value: REPRESENTATION_TYPE.OWN_COMPANY,
    label: "Empresa própria",
  },
  {
    value: REPRESENTATION_TYPE.EXTERNAL_COMPANY,
    label: "Empresa de terceiros",
  },
]

export const UF = [
  { label: "Acre", value: "AC" },
  { label: "Alagoas", value: "AL" },
  { label: "Amapá", value: "AP" },
  { label: "Amazonas", value: "AM" },
  { label: "Bahia", value: "BA" },
  { label: "Ceará", value: "CE" },
  { label: "Distrito Federal", value: "DF" },
  { label: "Espírito Santo", value: "ES" },
  { label: "Goiás", value: "GO" },
  { label: "Maranhão", value: "MA" },
  { label: "Mato Grosso", value: "MT" },
  { label: "Mato Grosso do Sul", value: "MS" },
  { label: "Minas Gerais", value: "MG" },
  { label: "Pará", value: "PA" },
  { label: "Paraíba", value: "PB" },
  { label: "Paraná", value: "PR" },
  { label: "Pernambuco", value: "PE" },
  { label: "Piauí", value: "PI" },
  { label: "Rio de Janeiro", value: "RJ" },
  { label: "Rio Grande do Norte", value: "RN" },
  { label: "Rio Grande do Sul", value: "RS" },
  { label: "Rondônia", value: "RO" },
  { label: "Roraima", value: "RR" },
  { label: "Santa Catarina", value: "SC" },
  { label: "São Paulo", value: "SP" },
  { label: "Sergipe", value: "SE" },
  { label: "Tocantins", value: "TO" },
]

export const AUDIO_OR_TEXT = [
  { label: "Áudio", value: "AUDIO" },
  { label: "Texto", value: "TEXTO" },
]

export const SEX_ORIENTATION = [
  {
    value: "NAO_INFORMAR",
    label: "Prefiro não informar",
  },
  { label: "Lésbica", value: "LESBICA" },
  { label: "Gay", value: "GAY" },
  { label: "Bissexual", value: "BISSEXUAL" },
  { label: "Queer", value: "QUEER" },
  { label: "Assexual", value: "ASSEXUAL" },
  { label: "Pansexual", value: "PANSEXUAL" },
  { label: "Heterossexual", value: "HETEROSSEXUAL" },
  { label: "Outra", value: OTHER_VALUE },
]

export const PERSONAL_PRONOUM = [
  {
    value: "NAO_INFORMAR",
    label: "Prefiro não informar",
  },
  { label: "Ela/dela", value: "ELA_DELA" },
  { label: "Ele/dele", value: "ELE_DELE" },
  { label: "Elu/delu", value: "ELU_DELU" },
  { label: "Outro", value: OTHER_VALUE },
]

export const HEAR_ABOUT_US = [
  { value: "FACEBOOK", label: "Facebook" },
  { value: "INSTAGRAM", label: "Instagram" },
  { value: "YOUTUBE", label: "YouTube" },
  { value: "SITE", label: "Site" },
  { value: "MAILING", label: "Mailing" },
  { value: "TV", label: "TV" },
  { value: "RADIO", label: "Rádio" },
  { value: "PESSOAS_PROXIMAS", label: "Pessoas próximas" },
  { value: OTHER_VALUE, label: "Outros" },
]

export const EXTRA_LINK_TYPES = [
  { label: "Entrevista", value: "ENTREVISTA" },
  { label: "Show", value: "SHOW" },
  { label: "Performance", value: "PERFORMANCE" },
]

export const MONTHS = [
  { label: "Janeiro", value: "01" },
  { label: "Fevereiro", value: "02" },
  { label: "Março", value: "03" },
  { label: "Abril", value: "04" },
  { label: "Maio", value: "05" },
  { label: "Junho", value: "06" },
  { label: "Julho", value: "07" },
  { label: "Agosto", value: "08" },
  { label: "Setembro", value: "09" },
  { label: "Outubro", value: "10" },
  { label: "Novembro", value: "11" },
  { label: "Dezembro", value: "12" },
]
